import { type ModerationDataSource } from '../../data/moderation.data-source'
import { type ModerationActionType, actionToApiAction } from '../models/moderation.model'

export class ApplyActionInteractor {
  constructor(private readonly dataSource: ModerationDataSource) {}

  async execute(messageId: string, action: ModerationActionType): Promise<void> {
    const apiAction = actionToApiAction[action]
    await this.dataSource.performAction(messageId, apiAction)
  }
}
